<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="header"
        :items="listSubModality"
        no-data-text="Nenhuma Sub-Modalidade foi encontrada"
        loading-text="Carregando Sub-Modalidades..."
        class="sub-modality-table base__datatable"
        hide-default-footer
        @click:row="showModalEdit"
        :search="filter"
      >
        <template v-slot:[`item.nome`]="{ item }">
          <div :class="borderColor(item.ativo)">
            <div class="sub-modality-table__padding">
              {{ item.nome }}
            </div>
          </div>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>
<script>
const tableHeaders = [
  { text: "Sub-modalidade", value: "nome", sortable: true },
  { text: "Status", value: "status.nome", sortable: true }
];
const colorByStatus = [
  { color: "green", status: true },
  { color: "pink", status: false }
];
import { mapState } from "vuex";
export default {
  data: () => ({
    header: tableHeaders,
    listColorByStatus: colorByStatus
  }),
  computed: {
    ...mapState("modality", ["listSubModality"]),
    ...mapState(["userPermissions"]),
    canSeeEditModality() {
      return this.userPermissions.acoes.some(x => x.id == "editar_modalidade");
    }
  },
  methods: {
    borderColor(item) {
      const status = this.listColorByStatus.find(x => x.status == item);
      return `sub-modality-table__border-${status.color}`;
    },
    showModalEdit(item) {
      if (this.canSeeEditModality) this.$emit("edit", item);
    }
  },
  props: {
    filter: {
      type: String
    }
  }
};
</script>
<style lang="sass">
.sub-modality-table__
  &border-green
    border-left: 5px solid #49DCBB
  &border-pink
    border-left: 5px solid #EF5350
  &padding
    padding: 0px 15px !important
    height: 36px !important
    display: flex
    align-items: center
.sub-modality-table
  tbody tr
    cursor: pointer
.sub-modality-table.v-data-table.theme--light
  tbody tr td:first-child
    padding: 2px 0px !important
  tbody tr td:last-of-type:not(:only-of-type)
    text-align: end !important
  thead tr th:last-child
    text-align: end !important
</style>
